module.exports = __webpack_public_path__ + "img/sq-9.bff644ac.jpg";